import { MainContent, TopBar } from '@domain-group/suit-theme'

import useMainNavigation from '@hooks/useMainNavigation'

import DashboardSearch from '@components/DashboardSearch'
import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Admin/components/MainNavigation'

import QualityControlRoutes from './routes'

const QualityControl = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  return (
    <>
      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        searchComponent={<DashboardSearch searchEntities={['LayoutTemplate', 'TaskList', 'TemplatePage', 'TemplatePagePartial']} />}
      />

      {/*
       // @ts-expect-error TS2739 */}
      <MainNavigation />

      <MainContent offset={{ top: TopBar.topBarHeight }}>
        <QualityControlRoutes />
      </MainContent>
    </>
  )
}

export default QualityControl
